import { Alert, Translator } from '@itarget/shared'
import { Box } from '@material-ui/core'
import { useStyles } from '../styles'
import Wallet from '../../../components/Wallet'
import Statement from '../../../components/Statement'
import CampaignCollection from '../../../components/CampaignCollection'
import { FidelityTabs } from '../../../components/FIdelityTabs'
import RenderComponent from './RenderComponent'
import FidelityContextProvider from '../../../context/FidelityContext'

const FidelityDashboard = ({ alert }) => {
  const classes = useStyles()

  return (
    <FidelityContextProvider>
      <Box className={classes.root}>
        {alert.open && (
          <Box>
            <Alert.Root>
              <Alert.Container>
                <Alert.Title icon="lock">
                  <Translator transRef="translation.Programa cashback bloqueado" />
                </Alert.Title>
                <Alert.Content>{alert.message}</Alert.Content>
              </Alert.Container>
            </Alert.Root>
          </Box>
        )}
        <FidelityTabs />
        <RenderComponent component="WALLET">
          <Wallet.Root>
            <Wallet.Balance />
            <Wallet.Consolidation />
            <Wallet.LatestMovements />
          </Wallet.Root>
        </RenderComponent>
        <RenderComponent component="STATEMENT">
          <Statement.Root>
            <Statement.Filter />
            <Statement.Group />
          </Statement.Root>
        </RenderComponent>
        <RenderComponent component="CAMPAIGN">
          <CampaignCollection.Root>
            <CampaignCollection.Filter />
            <CampaignCollection.Group />
          </CampaignCollection.Root>
        </RenderComponent>
      </Box>
    </FidelityContextProvider>
  )
}

export default FidelityDashboard
